import React from 'react';
import { Box, Divider, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function PublicFooter() {
  return (
    <Box
      component="footer"
      sx={{
        px: { xs: 2, md: 4 },
        py: { xs: 4, md: 5 },
        bgcolor: 'grey.50',
        borderTop: '1px solid rgba(14, 44, 84, 0.08)',
      }}
    >
      <Stack
        spacing={3}
        sx={{ maxWidth: 1080, mx: 'auto' }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
              VENDX Genie
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: '0.95rem', mt: 0.5 }}>
              AI-powered transcription for meetings, notes, and summaries.
            </Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Link
              component={RouterLink}
              to="/"
              underline="none"
              color="text.primary"
              sx={{ fontWeight: 600 }}
            >
              Home
            </Link>
            <Link
              component={RouterLink}
              to="/privacy"
              underline="none"
              color="text.primary"
              sx={{ fontWeight: 600 }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/support"
              underline="none"
              color="text.primary"
              sx={{ fontWeight: 600 }}
            >
              Support
            </Link>
          </Stack>
        </Stack>

        <Divider sx={{ borderColor: 'rgba(14, 44, 84, 0.08)' }} />

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={1}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            © 2000-{new Date().getFullYear()} MavenVista Technologies Pvt. Ltd. All rights reserved.
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Need help? <Link href="mailto:genie@mavenvista.com" underline="always">genie@mavenvista.com</Link>
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
